import React, { useState } from 'react';
import { PatchNoteImageDialog } from './PatchNoteImageDialog/PatchNoteImageDialog.tsx';
import { getImageAltText } from './PatchNoteImageDialog/getImageAltText.ts';
import { resolveImageUrl } from './PatchNoteImageDialog/resolveImageUrl.ts';
import styles from './PatchNoteImageLink.module.scss';
import { isExternalImage } from './isExternalImage.ts';
const IMAGE_LINK_CONFIG = {
    before: {
        icon: '⬅️',
        title: {
            key: 'strings:popups.patchNote.before'
        }
    },
    after: {
        icon: '➡️',
        title: {
            key: 'strings:popups.patchNote.after'
        }
    }
};
export function PatchNoteImageLink({ type, imagePath, onExternalClick }) {
    const { icon, title } = IMAGE_LINK_CONFIG[type];
    const [open, setOpen] = useState(false);
    const [imageUrl, setImageUrl] = useState(null);
    if (isExternalImage(imagePath)) {
        return /*#__PURE__*/ React.createElement("span", {
            className: styles.imageLink,
            onClick: ()=>onExternalClick(imagePath)
        }, icon);
    }
    const handleClick = async ()=>{
        try {
            if (imageUrl == null) {
                const url = await resolveImageUrl(imagePath);
                setImageUrl(url);
            }
            setOpen(true);
        } catch  {
            return;
        }
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("span", {
        className: styles.imageLink,
        onClick: ()=>void handleClick()
    }, icon), imageUrl != null && /*#__PURE__*/ React.createElement(PatchNoteImageDialog, {
        open: open,
        onClose: ()=>setOpen(false),
        title: title,
        imageUrl: imageUrl,
        alt: getImageAltText(imagePath)
    }));
}
